// extracted by mini-css-extract-plugin
export default {"icon":"icon___ww8TURN","tooltip":"tooltip___ww8TURN"};